import CategoryPage from '../components/CategoryPage';

export default function Series() {
  return <CategoryPage type="series" title="Series" />;
}
